import { isAmazonLocker } from './amazonLocker';

// A locker is a classic locker (nature C) or an Amazon locker (nature J in France)
export const isLocker = ps => ps?.CodeNature === 'C' || isAmazonLocker(ps);

export function sortLockersFirstStable(list) {
  return list
    .map((ps, idx) => ({ ps, idx, pri: isLocker(ps) ? 1 : 0 }))
    .sort((a, b) => b.pri - a.pri || a.idx - b.idx)
    .map(x => x.ps);
}
